import * as api from "../../api";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useDispatch } from "react-redux";

import Head from "../../components/Head/Head";
import NavBar from "../../components/NavBar/NavBar";
import InstantQuote from "../../components/InstantQuote/InstantQuote";
import ContactUs from "../../components/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";
import { ALERT } from "../../constants/actionTypes";

import "./Pricing.css";
import { Close, Language } from "@material-ui/icons";

const Pricing = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [professional, setProfessional] = useState(0.2);
  const [certified, setCertified] = useState(0.2);
  const [openRequest, setOpenRequest] = useState(false);
  const [service, setService] = useState("");
  const [category, setCategory] = useState("");
  const [request, setRequest] = useState({
    organization: "",
    name: "",
    email: "",
    phone: "",
    details: "",
  });
  const [addson, setAddson] = useState({
    notarization: 0,
    sworn: 0,
    certified: 0,
    apostilles: 0,
  });
  const disable =
    loading ||
    request.organization === "" ||
    request.name === "" ||
    request.email === "" ||
    request.phone === "";

  const handleSelectProfessional = (e) => {
    setProfessional(Number(e.target.value));
  };

  const handleSelectCertified = (e) => {
    setCertified(Number(e.target.value));
  };

  const handleCheck = (e) => {
    if (!e.target.checked) return setAddson({ ...addson, [e.target.name]: 0 });
    setAddson({ ...addson, [e.target.name]: Number(e.target.value) });
  };

  const handleChange = (e) => {
    setRequest({ ...request, [e.target.name]: e.target.value });
  };

  const handleOpenRequest = (service, category) => {
    setService(service);
    setCategory(category);
    setOpenRequest(true);
  };

  const sendRequest = async () => {
    if (disable) return false;
    setLoading(true);

    try {
      await api.createProject({
        ...request,
        service,
        category,
      });
      await api.counter({ new_requests: 1 });
      setRequest({
        organization: "",
        name: "",
        email: "",
        phone: "",
        details: "",
      });
      setOpenRequest(false);
      dispatch({
        type: ALERT,
        payload: {
          severity: "success",
          message: "Request sent successfully, we will get in touch soon",
          duration: 5000,
          display: true,
        },
      });
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location.hash.slice(1).trim() !== "") {
      const element = document.getElementById(location.hash.slice(1).trim());

      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  useEffect(() => {
    if (openRequest)
      document.getElementsByTagName("BODY")[0].style.overflow = "hidden";
    else document.getElementsByTagName("BODY")[0].style.overflow = "auto";
  }, [openRequest]);

  return (
    <>
      <NavBar white pricing />
      <Head
        title={"Oneconverse price"}
        description={
          "Oneconverse is a trusted translation & interpretation agency. Go global with our certified translation, interpretation services, and translators near you."
        }
        keywords={
          "translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations"
        }
      />

      <div className="pricing__hero container d-flex align-center justify-end">
        <div className="h-100">
          <h2 className="font-large">
            Check Out Our Affordable and available prices
          </h2>
          <p className="font-big font-heavy py-40">
            Many factors affect translation rates, including task volume &
            urgency, language, and industry involved. Learn more with us and
            calculate your cost.
          </p>
        </div>
      </div>
      <div className="pricing__prices container">
        <div id="translation" className="pricing__prices__head mx-auto py-40">
          <h2 className="font-normal font-heavy text-center py-10">
            We give the best prices for
          </h2>
          <h3 className="font-subhead text-center py-5">
            Translation Services
          </h3>
          <p className="font-heavy font-big text-center py-10">
            Our professional translation services available in over 120
            Languages by our qualified translators.
          </p>
        </div>
        <div className="grid c-3 py-40 gap-40">
          <div className="translation__pricing d-flex flex-column align-center justify-center p-20">
            <h2 className="pb-20">GENERAL</h2>
            <h2 className="pb-10 font-heavy">General Content</h2>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <h3 className="font-large">
                <span className="font-big">$</span>0.17
              </h3>
              <span className="font-big font-heavy">Per Word</span>
            </div>
            <ul className="font-heavy font-big">
              <li className="lh-lg">Brand</li>
              <li className="lh-lg">Social Media</li>
              <li className="lh-lg">Emails</li>
              <li className="lh-lg">Native Translation (Non-Formal)</li>
              <li className="lh-lg">etc.</li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20"
              onClick={() => history.push("/quote")}
            >
              Get Started
            </button>
          </div>
          <div className="translation__pricing d-flex flex-column align-center justify-center p-20">
            <h2 className="pb-20">PROFESSIONAL</h2>
            <select
              className="w-100 border-0 outline-0 py-10 px-20 font-big mb-20"
              onChange={handleSelectProfessional}
              value={professional}
            >
              <option value={0.2}>Software / IT</option>
              <option value={0.21}>Legal</option>
              <option value={0.19}>Marketing</option>
              <option value={0.28}>Medical</option>
              <option value={0.22}>Scientific</option>
              <option value={0.22}>Technical</option>
              <option value={0.24}>Gaming</option>
              <option value={0.19}>Ad-word</option>
              <option value={0.2}>Cryto / Forex</option>
              <option value={0.19}>Automotive</option>
              <option value={0.19}>Finance</option>
              <option value={0.19}>Patents</option>
              <option value={0.19}>Mobile Apps</option>
              <option value={0.19}>Tourism</option>
              <option value={0.19}>ELearning / Training</option>
            </select>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <h3 className="font-large">
                <span className="font-big">$</span>
                {professional.toFixed(2)}
              </h3>
              <span className="font-big font-heavy">Per Word</span>
            </div>
            <ul className="font-heavy font-big">
              <li className="lh-lg">Industry Expert</li>
              <li className="lh-lg">Industry Specific</li>
              <li className="lh-lg">Detailed</li>
              <li className="lh-lg">Versatile</li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20"
              onClick={() => history.push("/quote")}
            >
              Get Started
            </button>
          </div>
          <div className="translation__pricing d-flex flex-column align-center justify-center p-20">
            <h2 className="pb-20">CERTIFIED</h2>
            <select
              className="w-100 border-0 outline-0 py-10 px-20 font-big mb-20"
              onChange={handleSelectCertified}
              value={certified}
            >
              <option value={0.2}>Software / IT</option>
              <option value={0.21}>Legal</option>
              <option value={0.19}>Marketing</option>
              <option value={0.28}>Medical</option>
              <option value={0.22}>Scientific</option>
              <option value={0.22}>Technical</option>
              <option value={0.24}>Gaming</option>
              <option value={0.19}>Ad-word</option>
              <option value={0.2}>Cryto / Forex</option>
              <option value={0.19}>Automotive</option>
              <option value={0.19}>Finance</option>
              <option value={0.19}>Patents</option>
              <option value={0.19}>Mobile Apps</option>
              <option value={0.19}>Tourism</option>
              <option value={0.19}>ELearning / Training</option>
            </select>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <h3 className="font-large">
                <span className="font-big">$</span>
                {certified.toFixed(2)}
              </h3>
              <span className="font-big font-heavy">Per Word</span>
              <span className="font-normal font-bolder">
                + $
                {(
                  addson.notarization +
                  addson.sworn +
                  addson.certified +
                  addson.apostilles
                ).toFixed(2)}
              </span>
            </div>
            <ul className="font-heavy font-big list-none">
              <li className="lh-lg">
                <label>
                  <input
                    type="checkbox"
                    name="certified"
                    value={0}
                    onChange={handleCheck}
                  />{" "}
                  <span>Certified Translation</span>
                </label>
              </li>
              <li className="lh-lg">
                <label>
                  <input
                    type="checkbox"
                    name="apostilles"
                    value={130}
                    onChange={handleCheck}
                  />{" "}
                  <span>Apostilles</span>
                </label>
              </li>
              <li className="lh-lg">
                <label>
                  <input
                    type="checkbox"
                    name="sworn"
                    value={56}
                    onChange={handleCheck}
                  />{" "}
                  <span>Sworn Translation</span>
                </label>
              </li>
              <li className="lh-lg">
                <label>
                  <input
                    type="checkbox"
                    name="notarization"
                    value={80}
                    onChange={handleCheck}
                  />{" "}
                  <span>Notarization</span>
                </label>
              </li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20"
              onClick={() => history.push("/quote")}
            >
              Get Started
            </button>
          </div>
        </div>

        <div
          id="interpretation"
          className="pricing__prices__head mx-auto py-40"
        >
          <h3 className="font-subhead text-center py-10 mt-40">
            Interpretation Rates
          </h3>
          <p className="font-heavy font-big text-center py-10">
            Our professional Interpretation services are available in over 120
            Languages by our qualified Interpreters.
          </p>
        </div>
        <div className="grid c-3 pt-40 gap-40">
          <div className="interpretation__pricing d-flex flex-column align-center justify-center p-20 mb-40">
            <h2 className="pb-20">TELEPHONE</h2>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <span className="font-bold">From</span>
              <h3 className="font-large">
                <span className="font-big">$</span>300
              </h3>
              <span className="font-big font-heavy">Per Hour</span>
            </div>
            <ul className="font-heavy font-big">
              <li className="lh-lg">Arabic</li>
              <li className="lh-lg">Chinese</li>
              <li className="lh-lg">Japanese</li>
              <li className="lh-lg">Hindi</li>
              <li className="lh-lg">Others</li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("interpretation", "telephone")}
            >
              Get Started
            </button>
          </div>
          <div className="interpretation__pricing d-flex flex-column align-center justify-center p-20 mb-40">
            <h2 className="pb-20">ESCORT</h2>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <span className="font-bold">From</span>
              <h3 className="font-large">
                <span className="font-big">$</span>420
              </h3>
              <span className="font-big font-heavy">Per Day</span>
            </div>
            <ul className="font-heavy font-big">
              <li className="lh-lg">English</li>
              <li className="lh-lg">French</li>
              <li className="lh-lg">Spanish</li>
              <li className="lh-lg">Portugese</li>
              <li className="lh-lg">Others</li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("interpretation", "escort")}
            >
              Get Started
            </button>
          </div>
          <div className="interpretation__pricing d-flex flex-column align-center justify-center p-20 mb-40">
            <h2 className="pb-20">CONFERENCE</h2>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <span className="font-bold">From</span>
              <h3 className="font-large">
                <span className="font-big">$</span>720
              </h3>
              <span className="font-big font-heavy">Per Day</span>
            </div>
            <ul className="font-heavy font-big">
              <li className="lh-lg">Swahili</li>
              <li className="lh-lg">Korean</li>
              <li className="lh-lg">Dutch</li>
              <li className="lh-lg">Russian</li>
              <li className="lh-lg">Others</li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("interpretation", "conference")}
            >
              Get Started
            </button>
          </div>
        </div>

        <div id="equipment" className="pricing__prices__head mx-auto py-40">
          <h3 className="font-subhead text-center py-10 mt-40">
            Equipment Rentage Rates
          </h3>
          <p className="font-heavy font-big text-center py-10">
            Our professional Interpretation services are available in over 120
            Languages by our qualified Interpreters.
          </p>
        </div>
        <div className="grid c-3 pt-40 gap-40">
          <div className="equipment__pricing d-flex flex-column align-center justify-center p-20 mb-40">
            <h2 className="pb-20">BASIC</h2>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <span className="font-bold">From</span>
              <h3 className="font-large">
                <span className="font-big">$</span>504
              </h3>
              <span className="font-big font-heavy">Per Day</span>
            </div>
            <ul className="font-heavy font-big">
              <li className="lh-lg">10 - 100 Headphones</li>
              <li className="lh-lg">10 - 100 Receivers</li>
              <li className="lh-lg">1 Interpreter's Booth</li>
              <li className="lh-lg">2 Delegate Microphones</li>
              <li className="lh-lg">1 Standby Pro-Technical</li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("equipment", "basic")}
            >
              Get Started
            </button>
          </div>
          <div className="equipment__pricing d-flex flex-column align-center justify-center p-20 mb-40">
            <h2 className="pb-20">PLUS</h2>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <span className="font-bold">From</span>
              <h3 className="font-large">
                <span className="font-big">$</span>744
              </h3>
              <span className="font-big font-heavy">Per Day</span>
            </div>
            <ul className="font-heavy font-big">
              <li className="lh-lg">101 - 200 Headphones</li>
              <li className="lh-lg">101 - 200 Receivers</li>
              <li className="lh-lg">2 Interpreter's Booths</li>
              <li className="lh-lg">5 Delegate Microphones</li>
              <li className="lh-lg">2 Standby Pro-Technicians</li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("equipment", "plus")}
            >
              Get Started
            </button>
          </div>
          <div className="equipment__pricing d-flex flex-column align-center justify-center p-20 mb-40">
            <h2 className="pb-20">MAX</h2>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <span className="font-bold">From</span>
              <h3 className="font-large">
                <span className="font-big">$</span>984
              </h3>
              <span className="font-big font-heavy">Per Day</span>
            </div>
            <ul className="font-heavy font-big">
              <li className="lh-lg">201 - 300 Headphones</li>
              <li className="lh-lg">201 - 300 Receivers</li>
              <li className="lh-lg">4 Interpreters' Booths</li>
              <li className="lh-lg">10 Delegate Microphones</li>
              <li className="lh-lg">5 Standby Pro-Technicians</li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("equipment", "max")}
            >
              Get Started
            </button>
          </div>
        </div>

        <div id="transcription" className="pricing__prices__head mx-auto py-40">
          <h3 className="font-subhead text-center py-10 mt-40">
            Transcription Rates
          </h3>
          <p className="font-heavy font-big text-center py-10">
            Our professional transcription services available in over 120
            Languages by our qualified transcribers.
          </p>
        </div>
        <div className="grid c-3 py-40 gap-40">
          <div className="transcription__pricing d-flex flex-column align-center justify-center p-20">
            <h2 className="pb-20">FIRST DRAFT</h2>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <span className="font-bold">From</span>
              <h3 className="font-large">
                <span className="font-big">$</span>1.19
              </h3>
              <span className="font-big font-heavy">Per Min</span>
            </div>
            <ul className="font-heavy font-big">
              <li className="lh-lg">99% Accuracy on Average</li>
              <li className="lh-lg">2 Business Day Delivery</li>
              <li className="lh-lg">Speaker ID's available</li>
              <li className="lh-lg">Timestamps Available</li>
              <li className="lh-lg">100% Human Transcription</li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("transcription", "first draft")}
            >
              Get Started
            </button>
          </div>
          <div className="transcription__pricing d-flex flex-column align-center justify-center p-20">
            <h2 className="pb-20">STANDARD</h2>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <span className="font-bold">From</span>
              <h3 className="font-large">
                <span className="font-big">$</span>2.39
              </h3>
              <span className="font-big font-heavy">Per Min</span>
            </div>
            <ul className="font-heavy font-big">
              <li className="lh-lg">99%+ Accuracy Guaranteed</li>
              <li className="lh-lg">1-3 Day Delivery</li>
              <li className="lh-lg">Speaker ID's Available</li>
              <li className="lh-lg">Timestamps Available</li>
              <li className="lh-lg">100% Human Transcription</li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("transcription", "standard")}
            >
              Get Started
            </button>
          </div>
          <div className="transcription__pricing d-flex flex-column align-center justify-center p-20">
            <h2 className="pb-20">VERBATIM</h2>
            <div className="d-flex flex-column align-center justify-center rounded-50">
              <span className="font-bold">From</span>
              <h3 className="font-large">
                <span className="font-big">$</span>3.59
              </h3>
              <span className="font-big font-heavy">Per Min</span>
            </div>
            <ul className="font-heavy font-big">
              <li className="lh-lg">100% Full Verbatim Style</li>
              <li className="lh-lg">1-3 Day Delivery</li>
              <li className="lh-lg">Speaker ID's available</li>
              <li className="lh-lg">Timestamps Available</li>
              <li className="lh-lg">100% Human Transcription</li>
            </ul>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("transcription", "verbatim")}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
      <div className="container">
        <h2 className="font-large text-center py-40">
          Some of the other services we offer
        </h2>
        <div className="others__pricing__grid grid c-3 py-40 gap-40">
          <div className="others__pricing d-flex flex-column align-center justify-center">
            <Language style={{ fontSize: "72" }} className="icon-blue my-20" />
            <p className="font-bigger font-bolder text-center mb-10">
              Legalization
            </p>
            <span className="font-big font-bold text-center mb-40">
              ~200 words
            </span>
            <p className="font-bold font-big text-center my-20">
              From $100 per page
            </p>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("legalization", "start")}
            >
              Get Started
            </button>
          </div>
          <div className="others__pricing d-flex flex-column align-center justify-center">
            <Language style={{ fontSize: "72" }} className="icon-blue my-20" />
            <p className="font-bigger font-bolder text-center mb-10">
              Authentication
            </p>
            <span className="font-big font-bold text-center mb-40">
              ~200 words
            </span>
            <p className="font-bold font-big text-center my-20">
              From $89 per page
            </p>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("authentication", "start")}
            >
              Get Started
            </button>
          </div>
          <div className="others__pricing d-flex flex-column align-center justify-center">
            <Language style={{ fontSize: "72" }} className="icon-blue my-20" />
            <p className="font-bigger font-bolder text-center mb-10">
              Eligibility Letter
            </p>
            <span className="font-big font-bold text-center mb-40">
              ~200 words
            </span>
            <p className="font-bold font-big text-center my-20">
              From $67 per page
            </p>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("eligibility letter", "start")}
            >
              Get Started
            </button>
          </div>
          <div className="others__pricing d-flex flex-column align-center justify-center">
            <Language style={{ fontSize: "72" }} className="icon-blue my-20" />
            <p className="font-bigger font-bolder text-center mb-10">
              Certified True Copy
            </p>
            <span className="font-big font-bold text-center mb-40">
              ~200 words
            </span>
            <p className="font-bold font-big text-center my-20">
              From $89 per page
            </p>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("certified true copy", "start")}
            >
              Get Started
            </button>
          </div>
          <div className="others__pricing d-flex flex-column align-center justify-center">
            <Language style={{ fontSize: "72" }} className="icon-blue my-20" />
            <p className="font-bigger font-bolder text-center mb-10">
              Power of Attorney
            </p>
            <span className="font-big font-bold text-center mb-40">
              ~200 words
            </span>
            <p className="font-bold font-big text-center my-20">
              From $78 per page
            </p>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("power of attorney", "start")}
            >
              Get Started
            </button>
          </div>
          <div className="others__pricing d-flex flex-column align-center justify-center">
            <Language style={{ fontSize: "72" }} className="icon-blue my-20" />
            <p className="font-bigger font-bolder text-center mb-10">
              Statutory Declaration
            </p>
            <span className="font-big font-bold text-center mb-40">
              ~200 words
            </span>
            <p className="font-bold font-big text-center my-20">
              From $111 per page
            </p>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() =>
                handleOpenRequest("statutory declaration", "start")
              }
            >
              Get Started
            </button>
          </div>
          <div className="others__pricing d-flex flex-column align-center justify-center">
            <Language style={{ fontSize: "72" }} className="icon-blue my-20" />
            <p className="font-bigger font-bolder text-center mb-10">
              Criminal Background
            </p>
            <span className="font-big font-bold text-center mb-40">
              ~200 words
            </span>
            <p className="font-bold font-big text-center my-20">
              From $84 per page
            </p>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("criminal background", "start")}
            >
              Get Started
            </button>
          </div>
          <div className="others__pricing d-flex flex-column align-center justify-center">
            <Language style={{ fontSize: "72" }} className="icon-blue my-20" />
            <p className="font-bigger font-bolder text-center mb-10">
              Letter of Invitation
            </p>
            <span className="font-big font-bold text-center mb-40">
              ~200 words
            </span>
            <p className="font-bold font-big text-center my-20">
              From $67 per page
            </p>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() => handleOpenRequest("letter of invitation", "start")}
            >
              Get Started
            </button>
          </div>
          <div className="others__pricing d-flex flex-column align-center justify-center">
            <Language style={{ fontSize: "72" }} className="icon-blue my-20" />
            <p className="font-bigger font-bolder text-center mb-10">
              Notarization / Apostilles
            </p>
            <span className="font-big font-bold text-center mb-40">
              ~200 words
            </span>
            <p className="font-bold font-big text-center my-20">
              From $80 per page
            </p>
            <button
              className="border-0 outline-0 font-heavy font-normal py-10 px-40 my-20 pointer"
              onClick={() =>
                handleOpenRequest("notarization / apostilles", "start")
              }
            >
              Get Started
            </button>
          </div>
        </div>
      </div>

      <div className="container">
        <InstantQuote />
      </div>
      {openRequest && (
        <div className="price__details__ctn d-flex align-center justify-center w-100">
          <div
            className="price__details__overlay pointer"
            onClick={() => setOpenRequest(false)}
          ></div>
          <div className="price__details">
            <div className="p-20">
              <form className="position-relative">
                <h2 className="font-subhead text-center pb-20">Request Form</h2>
                <Close
                  className="position-absolute t-0 r-0 pointer"
                  onClick={() => setOpenRequest(false)}
                />
                <label className="d-flex flex-column py-10">
                  <span className="font-heavy pb-5">
                    Organization<sup className="pl-5">*</sup>
                  </span>{" "}
                  <input
                    type="text"
                    className="border-0 outline-0 box-shadow-lg p-20"
                    value={request.organization}
                    name="organization"
                    onChange={handleChange}
                  />
                </label>
                <label className="d-flex flex-column py-10">
                  <span className="font-heavy pb-5">
                    Name<sup className="pl-5">*</sup>
                  </span>{" "}
                  <input
                    type="text"
                    className="border-0 outline-0 box-shadow-lg p-20"
                    value={request.name}
                    name="name"
                    onChange={handleChange}
                  />
                </label>
                <label className="d-flex flex-column py-10">
                  <span className="font-heavy pb-5">
                    Email Address<sup className="pl-5">*</sup>
                  </span>{" "}
                  <input
                    type="email"
                    className="border-0 outline-0 box-shadow-lg p-20"
                    value={request.email}
                    name="email"
                    onChange={handleChange}
                  />
                </label>
                <label className="d-flex flex-column py-10">
                  <span className="font-heavy pb-5">
                    Phone Number<sup className="pl-5">*</sup>
                  </span>{" "}
                  <input
                    type="tel"
                    className="border-0 outline-0 box-shadow-lg p-20"
                    value={request.phone}
                    name="phone"
                    onChange={handleChange}
                  />
                </label>
                <h3 className="font-big pt-20 pb-10">About Request</h3>
                <p className="font-heavy">
                  Please provide full details to help us quote more accurately.
                  If interpreters are required: languages and specialism. If
                  equipment is required: number of booths, receivers and
                  microphones, number of rooms (plenary, break out), room
                  layout, venue, etc.
                </p>
                <textarea
                  placeholder="..."
                  className="p-20 w-100 border-0 outline-0 box-shadow-lg mt-10"
                  value={request.details}
                  name="details"
                  onChange={handleChange}
                />
                <button
                  style={{ opacity: disable ? "0.6" : "" }}
                  className="d-flex align-center justify-center border-0 outline-0 font-bold font-big p-10 w-100 mt-20"
                  onClick={sendRequest}
                  disabled={disable}
                >
                  SUBMIT
                  {loading && <div className="spin-white ml-10"></div>}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
      <ContactUs />
      <Footer />
    </>
  );
};

export default Pricing;
